export default __webpack_public_path__ + "static/media/bernard_tung_body.9ab3f85d.png";